/**
 * Türkçe karakterlere uygun büyük harf dönüşümü
 * 
 * @param {string} text - Dönüştürülecek metin
 * @returns {string} - Türkçe karakterlere uygun büyük harf metin
 */
export const toTurkishUpperCase = (text) => {
  if (!text) return '';
  
  return text
    // Önce Türkçe karakterleri elle dönüştür
    .replace(/ı/g, 'I')
    .replace(/i/g, 'İ')
    .replace(/ğ/g, 'Ğ')
    .replace(/ü/g, 'Ü')
    .replace(/ş/g, 'Ş')
    .replace(/ö/g, 'Ö')
    .replace(/ç/g, 'Ç')
    // Sonra standart toUpperCase ile geri kalanını büyük harfe çevir
    .toUpperCase();
};

/**
 * Türkçe karakterleri normalize ederek arama yapmak için yardımcı fonksiyon
 * 
 * Türkçe özel karakterleri (ı, İ, ğ, Ğ, ü, Ü, ş, Ş, ö, Ö, ç, Ç) 
 * standart Latin karşılıklarına dönüştürür ve büyük harfe çevirir.
 * 
 * @param {string} text - Normalize edilecek metin
 * @returns {string} - Normalize edilmiş metin (büyük harf)
 */
export const normalizeForSearch = (text) => {
  if (!text) return '';
  
  return text
    .toUpperCase() // Büyük harfe çevir
    // Türkçe karakter dönüşümleri (büyük harf versiyonları)
    .replace(/I/g, 'I')
    .replace(/İ/g, 'I') 
    .replace(/ı/g, 'I')
    .replace(/Ğ/g, 'G')
    .replace(/ğ/g, 'G')
    .replace(/Ü/g, 'U')
    .replace(/ü/g, 'U')
    .replace(/Ş/g, 'S')
    .replace(/ş/g, 'S')
    .replace(/Ö/g, 'O')
    .replace(/ö/g, 'O')
    .replace(/Ç/g, 'C')
    .replace(/ç/g, 'C')
    // Ekstra boşlukları temizle
    .trim();
};

/**
 * İki metni Türkçe karakterler dikkate alınarak karşılaştırır
 * 
 * @param {string} searchTerm - Aranacak terim
 * @param {string} targetText - Hedef metin
 * @returns {boolean} - Eşleşme var mı?
 */
export const turkishSearch = (searchTerm, targetText) => {
  const normalizedSearchTerm = normalizeForSearch(searchTerm);
  const normalizedTargetText = normalizeForSearch(targetText);
  
  return normalizedTargetText.includes(normalizedSearchTerm);
};

/**
 * Birden fazla alanda Türkçe karakterlere uygun arama yapar
 * 
 * @param {string} searchTerm - Aranacak terim
 * @param {string[]} targetTexts - Aranacak metin listesi
 * @returns {boolean} - Herhangi bir alanda eşleşme var mı?
 */
export const turkishMultiSearch = (searchTerm, targetTexts) => {
  if (!searchTerm.trim()) return true;
  
  const normalizedSearchTerm = normalizeForSearch(searchTerm);
  
  return targetTexts.some(text => {
    const normalizedText = normalizeForSearch(text);
    return normalizedText.includes(normalizedSearchTerm);
  });
}; 